import { render, staticRenderFns } from "./DataList.vue?vue&type=template&id=3933effc&scoped=true"
import script from "./DataList.vue?vue&type=script&lang=js"
export * from "./DataList.vue?vue&type=script&lang=js"
import style0 from "./DataList.vue?vue&type=style&index=0&id=3933effc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3933effc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3933effc')) {
      api.createRecord('3933effc', component.options)
    } else {
      api.reload('3933effc', component.options)
    }
    module.hot.accept("./DataList.vue?vue&type=template&id=3933effc&scoped=true", function () {
      api.rerender('3933effc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/System/SystemInit/SplitTheData/DataList.vue"
export default component.exports